import React, { useContext, useState } from 'react';
import PropTypes from 'prop-types';
import { extend } from '@thd-nucleus/data-sources';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import classNames from 'classnames';
import { NearbyStores } from './NearbyStores';
import { ChangeStore } from './ChangeStore';
import { useSearchModelData } from '../../hooks/useSearchModelData';
// eslint-disable-next-line @harmony/stencil/no-import-css
import '../../styles/store-selector.scss';

const StoreSelectorContent = React.forwardRef((props, ref) => {
  const [changeStore, setChangeStore] = useState(false);

  const { data } = useSearchModelData();
  const { stores } = data?.searchModel?.metadata || {};
  const { channel } = useContext(ExperienceContext);

  if (!stores) return null;

  const isMobile = channel === 'mobile';

  const onChangeClick = () => {
    setChangeStore(!changeStore);
  };

  const {
    storeId,
    storeName,
    phone,
    address,
    nearByStores = []
  } = stores;

  const storeSearch = [
    {
      storeId,
      storeName,
      phone,
      address
    }
  ];

  nearByStores.forEach((store) => {
    storeSearch.push(store);
  });

  const { multiStoreCallback, setNearbyStores } = props;

  const contentClasses = classNames('store-selector__content', {
    'store-selector__content--mobile': isMobile
  });

  return (
    <div className={contentClasses} ref={ref}>
      {!changeStore && (
        <NearbyStores
          stores={storeSearch}
          onChangeClick={onChangeClick}
          multiStoreCallback={multiStoreCallback}
          setNearbyStores={setNearbyStores}
        />
      )}
      {changeStore && (
        <ChangeStore postalCode={address.postalCode} stores={storeSearch} onChangeClick={onChangeClick} />
      )}
    </div>
  );
});

StoreSelectorContent.displayName = 'StoreSelectorContent';

StoreSelectorContent.dataModel = extend(ChangeStore);

StoreSelectorContent.propTypes = {
  multiStoreCallback: PropTypes.func,
  setNearbyStores: PropTypes.func
};

StoreSelectorContent.defaultProps = {
  multiStoreCallback: () => { },
  setNearbyStores: () => { }
};

export { StoreSelectorContent };
